import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../translate/localization";
import CobeeTextField from "../../../../../app/components/CobeeTextField";
import useStyles from "../../styles";

export default function RowNumberQuotas({ numberOfQuotas, setNumberOfQuotas }) {
  const { secondColumn } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("common-messages.number-of-quotas")}:
        </Typography>
      </Grid>
      <Grid item xs={6} className={secondColumn}>
        <Grid item xs={4}>
          <CobeeTextField
            type="number"
            min={0}
            minWidth="100%"
            value={numberOfQuotas}
            onChange={(e) => setNumberOfQuotas(e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );
}

RowNumberQuotas.propTypes = {
  numberOfQuotas: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setNumberOfQuotas: PropTypes.func,
};

RowNumberQuotas.defaultProps = {
  numberOfQuotas: "o",
  setNumberOfQuotas: () => {},
};
